"use strict";

import React from 'react';

import ApplicationEvents from 'components/applicationEvents';
import { _I_, defineSimpleTerm } from 'components/locs';
import {  ViewItemDetailed  } from 'components/commonAssets';
import {  isExpired,  } from 'components/classInfoUtil';
import {  SourceListener  } from 'generics/dataBound';
import {
    refreshBlockedPairs,  blockedPairsSource,  blockedPairsKey,  getBlockedPairAffectAfter
  } from 'api/rpcAPICall';


import ViewItemMarketDetailsController from 'components/itemMarketDetailsController';

LogStream.enable("VIEWTRADEDIALOG");


export default class ViewTradeDialog extends React.Component  {
  constructor(props)  {
    super(props);

    this.userCurr = SettingsInjections.getUsedCurrency().market;

    this.closeAssetPage = () =>  {  ApplicationEvents.emit_async( "market.setCurrentAssetByHash" );  };
    this.closeAssetPageOnEsc = ( e ) =>  { if ( (e.key == "Esc") || (e.key == "Escape") ) this.closeAssetPage(); }
    this.stopPropagation = (e) =>  {  e.stopPropagation()  }
  }


  componentDidMount()  {
    document.addEventListener("keydown", this.closeAssetPageOnEsc );
  }


  componentWillUnmount()  {
    document.removeEventListener("keydown", this.closeAssetPageOnEsc );
  }


  renderMarketDetails(blockedAfter)  {
    const {  classInfo  }  = this.props;
    if ( !classInfo.marketable )
      return;

    const haveItems = (
        ( this.props.instances ) &&
        ( this.props.instances.length > 0) &&
        ( this.props.totalAmount > 0 )
      );

    const asssid  =  haveItems ? this.props.instances[0].id : null;
    return (
            <ViewItemMarketDetailsController
                appid={this.props.appid}
                ctxid={this.props.ctxid}
                classInfo={this.props.classInfo}
                market_name={this.props.classInfo.market_hash_name}
                haveItems={ haveItems }
                asssid={asssid}
                blockedAfter={blockedAfter}
                totalAmount={this.props.totalAmount}
                instances={this.props.instances}
              />
      );
  }


  render()  {
    const  {  appid, classInfo, totalAmount, instances  }  =  this.props;

    const pairKey = (classInfo.marketable && classInfo.market_hash_name) ?
                        blockedPairsKey({appId:appid, marketName:classInfo.market_hash_name}) :
                        "";

    return (

      <div  key={(classInfo||{}).classid}
            className="modal-backdrop-plate"
            onClick={ this.closeAssetPage }
          >

        <div  className="modal-holder-plate"
              onClick={this.stopPropagation}
            >
            <div className="view-trade-dialog">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <b>{_I_("ViewTradeDialog.caption")}</b>
                  <button
                          className="close pull-right"
                          type="button"
                          style={{color:"inherit"}}
                          onClick={ this.closeAssetPage }
                          >&times;</button>
                </div>

                <SourceListener blockedPairs={blockedPairsSource}>{
                  ({blockedPairs})  =>  {
                      const blockedAfter = getBlockedPairAffectAfter(blockedPairs[pairKey]);
                      return (
                          <div className="panel-body">

                            <ViewItemDetailed
                                  classInfo={classInfo}
                                  amount={this.props.totalAmount}
                                  appId={this.props.appid}
                                  blockedAfter={blockedAfter}
                                >
                            </ViewItemDetailed>

                            { this.renderMarketDetails(blockedAfter) }

                          </div>
                        );
                    }
                }</SourceListener>

              </div>
            </div>
        </div>
      </div>
    );
  }

}


defineSimpleTerm( "ViewTradeDialog.caption",  "Trade",       {
    "ru_RU": "Торговля",
    "cs_CZ": "Obchodovat",
    "fr_FR": "Commerce",
    "de_DE": "Handel",
    "it_IT": "Scambia",
    "ko_KR": "거래",
    "pl_PL": "Wymiana",
    "pt_PT": "Trade",
    "es_ES": "Comerciar",
    "zh_CN": "交易",
    "zh_TW": "交易"
} );

